import { requestPayload, apiEndpoint, isNull } from '../utils/common';
import { API, ERRORS } from '../constant';
import { post } from '../utils/http';

/**
 * UPI address of user
 *
 * @returns {Promise<Object>} - Promise object
 */
export function vpaDetails() {
  return post.call(this, apiEndpoint(API.VPA), requestPayload({})).then(
    data => {
      const _data = {};
      _data.resultInfo = data.resultInfo;
      _data.userProfile = data.sarvatraUserProfile;
      _data.vpa = data.sarvatraVpa;
      return _data;
    },
    error => {
      return error;
    }
  );
}

/**
 * Verify upi vpa handler
 * @param {String} vpa - upi vpa handler
 * @return {Promise<Object>} - upi api response object
 * */
export function validateVPA(vpa) {
  if (isNull(vpa)) {
    return Promise.reject(new Error(ERRORS.VPA));
  }

  return post.call(this, apiEndpoint(API.VALIDATE_VPA), requestPayload({ vpa }));
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/upi.js